import { h, render } from 'preact';
import * as util from 'lib/util';
import SDK from 'lib/sdk';

let root = document.getElementById('app');

function init() {
	let App = require('./components/app').default;

	root = render(<App />, document.body, root);
}

// 机器人 sid
const DEFAULT_SERVICE_SID = '1139630945';

// 获取用户信息
let bid = util.getCookie('WD_b_id');
let wduss = util.getCookie('WD_s_wduss');
let sid = util.getCookie('WD_s_id');

SDK.ready(DEFAULT_SERVICE_SID, wduss, sid, bid, (err, data) => {
	if (err) {
		return alert('信息获取错误，请刷新页面重试！');
	}
	
	init();
});



/** WEBPACK FOOTER **
 ** ./index.js
 **/